/* Configurable Micasa module; safe to re-render in the Shopify editor. */
window.MicasaInit.register("christmas-campaign",scope=>{
'use strict';
const tx=value=>window.MicasaText(value);

'use strict';let previous=null;
function isEnabled(){return window.MicasaConfig?.christmasCampaignEnabled!==false}
function sync(){const enabled=isEnabled();document.body.dataset.christmasOffer=enabled?'active':'inactive';
 document.querySelectorAll('[data-christmas-active]').forEach(node=>node.hidden=!enabled);
 document.querySelectorAll('[data-christmas-inactive]').forEach(node=>node.hidden=enabled);
 const poster=document.querySelector('[data-christmas-poster]'),archive=document.querySelector('[data-christmas-poster-archive]');
 const target=document.querySelector(enabled?'[data-christmas-poster-live]':'[data-christmas-poster-archive]');
 if(poster&&target&&poster.parentElement!==target)target.append(poster);
 if(!enabled&&previous!==enabled&&archive)archive.open=false;
 document.querySelectorAll('[data-season-slide="christmas"] img[data-campaign-active-alt],[data-season-slide="christmas"] img[data-active-alt]').forEach(img=>{const activeAlt=img.dataset.campaignActiveAlt??img.dataset.activeAlt??'',inactiveAlt=img.dataset.campaignInactiveAlt??img.dataset.inactiveAlt??activeAlt;img.alt=enabled?activeAlt:inactiveAlt});
 if(previous!==enabled){previous=enabled;window.dispatchEvent(new CustomEvent('micasa:christmascampaignchange',{detail:{enabled}}))}
 return enabled;
}
window.MicasaChristmasCampaign={isEnabled,sync,getState:()=>({enabled:isEnabled()})};sync();


});
